module.exports = __webpack_public_path__ + "testerstatic/media/icon-warning.fb1c2936.svg";